import React from 'react';

export const PageNotFound = () => {

    return (
        <React.Fragment>
            <div className="bg-black text-white">
                <div className="contain text-center flex justify-center items-center">
                Page Not Found
                </div>
            </div>
        </React.Fragment>
    );
}

export default PageNotFound;